const _ = require('lodash')
const {structure2mesh} = require('santa-mesh')
const stylePropName = key => _.head(key) === '-' ? key : _.kebabCase(key)

const renderStyle = ({id, stylesMap}) => {
    const css = `
    ${_(stylesMap).map((compStyle, compId) => `
#${compId} {
${_(compStyle).omitBy(_.isNil).map((value, key) => `    ${stylePropName(key)}: ${value};`).join('\n')}
}`).join('\n')}`

    return {[id]: css}
}


const getMeshStyles = (id, stylesMap) => renderStyle({
    id: `${id}-mesh-styles`,
    stylesMap: _.merge(
        stylesMap, {
            [`${id}inlineContent`]: {
                position: 'relative'
            },
            [`${id}centeredContent`]: {
                position: 'relative'
            },
            // To make sure overlaps and soap container does not block clicks on components underneath
            [`${id}inlineContent-gridWrapper`]: {
                'pointer-events': 'none'
            },
            [`${id}inlineContent-gridContainer > *`]: {
                'pointer-events': 'auto'
            },
            [`${id}inlineContent-gridContainer > [id$="-rotated-wrapper"]`]: {
                'pointer-events': 'none'
            },
            [`${id}inlineContent-gridContainer > [id$="-rotated-wrapper"] > *`]: {
                'pointer-events': 'auto'
            }
        }
    )
})

const getMeshResults = (compId, meshParams) => { //TODO: this logic should be in carmi
    const rotatedComponents = []
    const wedges = []
    const children = _.get(meshParams, 'structure.children[0].children[0].children', [])
    children.forEach(comp => {
        if (comp.id.includes('rotated-wrapper')) {
            rotatedComponents.push(...comp.children.map(child => child.id))
        } else if (comp.id.includes('wedge')) {
            wedges.push(comp.id)
        }
    })

    return {
        css: getMeshStyles(compId, meshParams.styles),
        wedges,
        rotatedComponents
    }
}

module.exports = {
    getMeshResults,
    structure2mesh
}
